export interface MenuModel {
  title?: string;
  permissionName?: string;
  icon?: string;
  name?: string;
  target?: string;
  component?: string;
  items: MenuModel[];
  action?: string;
  active: boolean;
}

const Menu: MenuModel[] = [
  <MenuModel>{
    title: 'Notfound',
    permissionName: 'Notfound',
    icon: 'chat_bubble',
    target: '_blank',
    name: '/notfound',
    action: 'dashboard',
    active: false
  },
  <MenuModel>{
    title: '系统设置',
    permissionName: 'SystemSettings',
    icon: 'settings',
    active: false,
    items: [
      <MenuModel>{
        name: 'productCategory',
        title: '商品分类',
        permissionName: 'SystemSettings.ProductCategory'
      },
      <MenuModel>{
        name: 'staffCount',
        title: '员工账号',
        permissionName: 'SystemSettings.Staff'
      },
      <MenuModel>{
        name: 'rolePermission',
        title: '角色权限',
        permissionName: 'SystemSettings.RolePermission'
      },
      <MenuModel>{
        name: 'customerLevel',
        title: '客户等级',
        component: 'CustomerLevel',
        permissionName: 'SystemSettings.CustomerLevel'
      }
    ]
  },
  <MenuModel>{
    title: '商品管理',
    permissionName: 'ProductManager',
    icon: 'add_shopping_cart',
    active: false,
    items: [
      <MenuModel>{
        name: 'productManage',
        title: '商品列表',
        permissionName: 'ProductManager.ProductsList'
      }
    ]
  },
  <MenuModel>{
    title: '库存管理',
    permissionName: 'InventoryManager',
    icon: 'store',
    active: false,
    items: [
      <MenuModel>{
        name: 'productStock',
        title: '商品库存',
        permissionName: 'InventoryManager.ProductInventory'
      },
      <MenuModel>{
        name: 'productionDateStock',
        title: '有效期查询',
        permissionName: 'InventoryManager.ProductionDateQuery'
      },
      <MenuModel>{
        name: 'inStock',
        title: '入库单',
        permissionName: 'InventoryManager.StockInOrder'
      },
      <MenuModel>{
        name: 'outStock',
        title: '出库单',
        permissionName: 'InventoryManager.StockOutOrder'
      },
      <MenuModel>{
        name: 'stockDetail',
        title: '出入库明细',
        permissionName: 'InventoryManager.StockDetail'
      }
    ]
  },
  <MenuModel>{
    title: '客户管理',
    permissionName: 'CustomerManager',
    icon: 'people',
    active: false,
    items: [
      <MenuModel>{
        name: 'customer_index',
        title: '客户列表',
        permissionName: 'CustomerManager.CustomerList'
      },
      <MenuModel>{
        name: 'customerDiscount',
        title: '客户折扣',
        permissionName: 'CustomerManager.CustomerDiscount'
      }
    ]
  },
  <MenuModel>{
    title: '订单管理',
    permissionName: 'OrderManager',
    icon: 'shopping_cart',
    active: false,
    items: [
      <MenuModel>{
        name: 'orderList',
        title: '订单列表',
        permissionName: 'OrderManager.OrderList'
      },
      <MenuModel>{
        name: 'allocation_index',
        title: '配货列表',
        permissionName: 'OrderManager.AllocationList'
      },
      <MenuModel>{
        name: 'shipmentManagement',
        title: '发货列表',
        permissionName: 'OrderManager.ShipmentList'
      }
    ]
  },
  <MenuModel>{
    title: '财务管理',
    permissionName: 'FinanceManager',
    icon: 'monetization_on',
    active: false,
    items: [
      <MenuModel>{
        name: 'capitalAccount',
        title: '资金账户',
        permissionName: 'FinanceManager.FinanceAccount'
      },
      <MenuModel>{
        name: 'rechargeList',
        title: '充值列表',
        permissionName: 'FinanceManager.RechargeList'
      },
      <MenuModel>{
        name: 'incomeExpenditureDetail',
        title: '收支明细',
        permissionName: 'FinanceManager.IncomeAndExpenditureDetails'
      }
    ]
  },
  <MenuModel>{
    title: '营销管理',
    permissionName: 'MarketingManager',
    icon: 'local_offer',
    active: false,
    items: [
      <MenuModel>{
        name: 'materials',
        title: '物料申请',
        permissionName: 'MarketingManager.MaterialApplication'
      }
    ]
  },
  <MenuModel>{
    title: '报表管理',
    permissionName: 'ReportManager',
    icon: 'list',
    active: false,
    items: [
      // <MenuModel>{
      //   name: 'commision_list',
      //   title: '提成报表',
      //   permissionName: 'ReportManager.RechargeCommissionReport'
      // },
      // <MenuModel>{
      //   name: 'good_report_list',
      //   title: '订单统计报表',
      //   permissionName: 'ReportManager.OrderCommissionReport'
      // },
      <MenuModel>{
        name: 'stock_report',
        title: '库存报表',
        permissionName: 'ReportManager.StockReport'
      }
    ]
  }
];
export default Menu;
